import { connect } from 'react-redux';

import { getErrorTargetId } from '../generic/ValidationErrors';
import getEventTargetValue from '../utils/get-event-target-value';
import { changeCampaignLine, removeLanguageLine } from './actions';
import CampaignLine from './CampaignLineTable/CampaignLine';

export default connect(
  ({ campaignEditor, contentfulCreatives }, props) => ({
    line: campaignEditor.campaignLinesById[props.id],
    areCreativesVisible: campaignEditor.campaignUI.areCreativesVisible,
    id: getErrorTargetId('campaignLines', props.id),
    contentfulCreatives,
  }),
  (dispatch, props) => ({
    onChange: event =>
      dispatch(
        changeCampaignLine(
          event.target.name,
          getEventTargetValue(event.target),
        ),
      ),
    onRemove: languageCode =>
      dispatch(removeLanguageLine(props.id, languageCode)),
  }),
)(CampaignLine);
